import { EmptyValuePlaceholder } from "@/components/ui"
import Address, { SingleLineAddress } from "@/components/Address"
import { formatDate, formatPrice } from '@/utils/formatters'

import { getFactureStatusLabel } from '@/features/entretiens/entretiensSlice'

export default ({item}) => {
 
  return (
    <tr>
      <td>
        <EmptyValuePlaceholder value={item.entretien_type_nom} />
      </td>
      <td>
        <EmptyValuePlaceholder value={formatDate(item.date_prestation)} />
      </td>
      <td>
        <SingleLineAddress data={item.bien} apptNumberPrefix={true} />
      </td>
      <td><EmptyValuePlaceholder value={formatPrice(item.montant)}/></td>
      <td>
        { item.facture_adresse ?
          <>
            <div>{item.facture_adresse?.nom || ''}</div>
              { item.facture_adresse?.complement && 
                <div className="uppercase">{item.facture_adresse.complement}</div>
              }
              <Address data={item?.facture_adresse || {}}/>
          </> :
          <EmptyValuePlaceholder />
        }
      </td>
      <td><EmptyValuePlaceholder value={getFactureStatusLabel(item.statut_facture)}/></td>
    </tr>
  )
}